import React, { useState } from 'react';
import cn from 'classnames';
import Footer from 'components/Footer/Footer';
// import { Link } from "react-router-dom";
import styles from './signin.module.scss';
import dash_styles from '../mychargers.module.scss';
import registration_styles from './registration.module.scss';

import { Auth } from 'aws-amplify';

async function logIn() {
  try {
    const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
    // const user = await Auth.signIn(username, password);
  } catch (error) {
    console.log('error signing in', error);
  }
}





export default function Registration(props) {
  const [userData, setUserData] = useState({ userName: '', password: '' });
  const [errorMessage, setErrorMessage] = useState({ value: '' });

  const handleInputChange = (e) => {
    setUserData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    logIn();
    //if username or password field is empty, return error message
    if (userData.userName === "" || userData.password === "") {
      setErrorMessage((prevState) => ({
        value: "Empty username/password field",
      }));
    } else if (
      userData.userName.toLowerCase() === "admin" &&
      userData.password === "test@1234"
    ) {
      //Signin Success
      localStorage.setItem('isLogin', true);
      window.location.pathname = "/myChargers";
    } else {
      //If credentials entered is invalid
      setErrorMessage((prevState) => ({ value: "Invalid username/password" }));
      return;
    }
  };

  return (
    <div className={`ldpg ${cn(dash_styles.main, dash_styles.main_layout)}`}>
      <div className={cn(dash_styles.main_flex, dash_styles.main_flex_layout)}>

        <img src={require('assets/logo.png').default} alt="Rectangle 1" className={cn(styles.logo_boxl, styles.logo_boxl_layout)} />

        <div className={cn(registration_styles.container)}>
          <form>
            <div style={{ width: '100%' }}>
              <div className={cn(styles.username, registration_styles.box1)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'User Name'}
                </h1>
                <input type="text" name="userName" autofocus="false" onChange={(e) => handleInputChange(e)} className={cn(styles.username_box, registration_styles.register_username_box_layout)} />
              </div>
              <div className={cn(styles.username, registration_styles.box2)}>
                
              </div>
              <div className={cn(styles.username, registration_styles.box1)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Password'}<span className={cn(registration_styles.important_sign)}>*</span>
                </h1>
                <input type="password" name="password" onChange={(e)=> handleInputChange(e)} id="password" minLength="8" className={cn(styles.username_box, registration_styles.register_username_box_layout)} />
              </div>
              <div className={cn(styles.username, registration_styles.box3)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Confirm Password'}<span className={cn(registration_styles.important_sign)}>*</span>
                </h1>
                <input type="password" name="password" onChange={(e)=> handleInputChange(e)} id="password" minLength="8" className={cn(styles.username_box, registration_styles.register_username_box_layout)} />
              </div>
              <div className={cn(registration_styles.clear_fix)}>
              <hr />
              </div>
              <div className={cn(styles.username, registration_styles.box1)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Last Name'}
                </h1>
                <input type="text" name="lastName" onChange={(e) => handleInputChange(e)} className={cn(styles.username_box, registration_styles.register_username_box_layout)} />
              </div>
              <div className={cn(styles.username, registration_styles.box3)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Email Address'}<span className={cn(registration_styles.important_sign)}>*</span>
                </h1>
                <input type="email" id="email" name="email" onChange={(e) => handleInputChange(e)} className={cn(styles.username_box, registration_styles.register_username_box_layout)} />
              </div>
              <div className={cn(styles.username, registration_styles.box1)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Contact Number'}<span className={cn(registration_styles.important_sign)}>*</span>
                </h1>
                <input type="tel" id="phone" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" onChange={(e) => handleInputChange(e)} className={cn(styles.username_box, registration_styles.register_username_box_layout)} />
              </div>
              <div className={cn(styles.username, registration_styles.box3)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Role'}<span className={cn(registration_styles.important_sign)}>*</span>
                </h1>
                {/* <input type="text" name="userName" onChange={(e) => handleInputChange(e)} className={cn(styles.username_box, registration_styles.register_username_box_layout)} /> */}
                <select name="role" id="role" className={cn(styles.username_box, registration_styles.register_username_box_layout)}>
                  <option value=""></option>
                  <option value="manager">Fleet Manager</option>
                  <option value="driver">Driver</option>
                </select>
              </div>
              <div className={cn(styles.username, registration_styles.box1)}>
                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                  {'Site'}
                </h1>
                {/* <input type="text" name="userName" onChange={(e) => handleInputChange(e)} className={cn(styles.username_box, registration_styles.register_username_box_layout)} /> */}
                <select name="site" id="site" className={cn(styles.username_box, registration_styles.register_username_box_layout)}>
                  <option value=""></option>
                  <option value="one">Site 1</option>
                  <option value="two">Site 2</option>
                  <option value="three">Site 3</option>
                  <option value="four">Site 4</option>
                </select>
              </div>
              
              <div className={cn(registration_styles.clear_fix)}>
              
              </div>

              <div className={cn(registration_styles.button_class)}>
                <button type='submit' disabled={!userData.userName || !userData.password} className={cn(styles.panel_group_big_title, styles.panel_group_big_title_layout, styles.panel_group_block, styles.panel_group_block_layout, registration_styles.submit_button)}>
                  {'Submit'}
                </button>
                <button type='submit' disabled={!userData.userName || !userData.password} className={cn(styles.panel_group_big_title, styles.panel_group_big_title_layout, styles.panel_group_block, styles.panel_group_block_layout, registration_styles.clear_button)}>
                  {'Clear'}
                </button>
              </div>
            </div>
            
          </form>
        </div>


        <Footer></Footer>

      </div>
    </div>

  );
}

Registration.inStorybook = true;
